import React from 'react';
import { get } from 'lodash';
import { ErrorAlert } from 'components/common/alerts';
import InlineLoader from 'components/common/loaders/InlineLoader';
import { PropTypes } from 'prop-types';
import LoaderTracker from 'components/common/loaders/LoaderTracker';

const getDataFilter = (res) => {
  if (res && res.data !== undefined) {
    return true;
  }
  return false;
};

const getErrorFilter = (res) => {
  if (res && res.error !== undefined) {
    return true;
  }
  return false;
};

const getFetchingFilter = (res) => get(res, 'fetching', false);

const dataReducer = (dataMap) => (props, key) => {
  const res = dataMap[key];
  const returnProps = {
    ...props,
    [key]: res.data,
  };
  if (res.paging) {
    returnProps.paging = {
      ...props.paging,
      [key]: res.paging,
    };
  }
  if (res.reexecuteQuery) {
    returnProps.reexecuteQuery = {
      ...props.reexecuteQuery,
      [key]: res.reexecuteQuery,
    };
  }
  return returnProps;
};

export const DataContainer = ({
  dataMap,
  displayComponent: DisplayComponent,
  loaderComponent: LoaderComponent,
  errorComponent: ErrorComponent,
  loadEventName,
  loadEventProps,
  ...rest
}) => {
  const keys = Object.keys(dataMap);
  const inputs = Object.values(dataMap);
  const data = inputs.filter(getDataFilter);
  const errors = inputs.filter(getErrorFilter);
  const fetching = inputs.filter(getFetchingFilter)[0]?.fetching;

  if (errors.length > 0) {
    const errorMessages = errors.map((res) => res.error);
    return <ErrorComponent content={errorMessages} {...rest} />;
  }
  if (data.length === keys.length) {
    const combinedProps = keys.reduce(dataReducer(dataMap), rest);
    return <DisplayComponent {...combinedProps} />;
  }
  return (
    <LoaderTracker
      Loader={LoaderComponent || InlineLoader}
      loadEventName={loadEventName}
      loadEventProps={loadEventProps}
      fetching={fetching}
    />
  );
};

DataContainer.propTypes = {
  dataMap: PropTypes.object.isRequired,
  displayComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  loadEventName: PropTypes.string,
  loadEventProps: PropTypes.object,
  loaderComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  errorComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

DataContainer.defaultProps = {
  loadEventName: undefined,
  loadEventProps: {},
  loaderComponent: undefined,
  errorComponent: ErrorAlert,
};

export default DataContainer;
